import React, { useState } from "react";
import PropTypes from "prop-types";
import { Translate } from "react-redux-i18n";
import { CheckboxRadio } from "cakemail-ui-components/lib/react";

export function ManageAssetDialogContent() {
	const [checked, setChecked] = useState(false);
	return (
		<div className="brandRepoSetup">
			<Translate value={"app-brand-brand-repo-manage-dialog-desc"} />
			<CheckboxRadio
				type="checkbox"
				label={
					<Translate value="app-brand-brand-repo-manage-dialog-checkbox-label" />
				}
				checked={checked}
				onChange={(e) => {
					if (e.currentTarget.checked) {
						window.localStorage.setItem(
							"show-brand-manage-asset-dialog",
							false
						);
					} else {
						window.localStorage.removeItem("show-brand-manage-asset-dialog");
					}
					setChecked(e.currentTarget.checked);
				}}
			/>
		</div>
	);
}

ManageAssetDialogContent.propTypes = {
	resellerName: PropTypes.string,
};

ManageAssetDialogContent.defaultProps = {
	resellerName: "",
};

export default ManageAssetDialogContent;
